@if (
  currentOfficeSystemRecordingResource.isLoading() ||
  targetOfficeSystemRecordingResource.isLoading() ||
  integrationSystemRecordingsResource.isLoading()
) {
  <app-loading />
} @else {
  <app-system-recording-integration-panels
    [projectId]="projectId()"
    [currentOfficeSystemRecording]="currentOfficeSystemRecordingResource.value()!"
    [targetOfficeSystemRecording]="targetOfficeSystemRecordingResource.value()!"
    [integrationSystemRecordings]="integrationSystemRecordingsResource.value()!"
  />
}
